import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { advantagesCards, AdvantagesCard } from 'sections/DigitalTools/CargoesFlow/data';
import Card from 'components/Card';
import styles from 'styles/pages/DigitalTools/CargoesFlow/CargoesFlow.module.scss';

const cn = classNames.bind(styles);

const SectionAdvantages = (): ReactElement => {
  const advantagesCardItems = advantagesCards.map((card: AdvantagesCard) => {
    return (
      <Card className={cn('advantages__card')} key={card.id}>
        <div className={cn('advantages__card-content')}>
          <Card.Header className={cn('advantages__card-title-box')}>
            <div className={cn('advantages__card-icon')}>
              <img src={`/images/pages/DigitalTools/CargoesFlow/${card.icon}`} alt={card.alt} />
            </div>
            <h3 className={cn('advantages__card-title')}>{card.title}</h3>
          </Card.Header>
          <Card.Content className={cn('advantages__card-description')}>
            <p>{card.description}</p>
          </Card.Content>
        </div>
      </Card>
    );
  });

  return (
    <section className={cn('advantages')}>
      <div className={cn('container')}>
        <h2 className={cn('advantages__title')}>Why choose flow</h2>
        <div className={cn('advantages__cards')}>{advantagesCardItems}</div>
      </div>
    </section>
  );
};

export default SectionAdvantages;
